module.exports = __webpack_public_path__ + "img/KSC06269.b457170c.jpg";